import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import {
    TableContentForLeafCollectionVarianceReport,
    TableContentForSumLeafCollectionVarianceReport
} from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { LeafCollectionVarianceReportSchemaObject } from "../leafCollectionVarianceReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';

const screenCode = "LEAFCOLLECTIONVARIANCEDETAILSREPORT";

export function LeafCollectionVarianceReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);

    const [leafCollectionVariance, setLeafCollectionDetails] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0",
        date: "",
        varinaceLimit: ""
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        factory: "0",
        route: "0",
        date: "",
        varinaceLimit: ""
    });

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(LeafCollectionVarianceReportSchemaObject).options({ allowUnknown: true });
    const initialContentRownames = ["fieldCollectionPointCode", "fieldCollectionPointName", "fieldCardNumber",
        "filedRegistrationNumber", "filedDate", "filedTime", "collectionTypeName", "filedTagNumber", "fieldGrossAmount_Kg",
        "fieldNetAmount_Kg", "factoryGrossAmount_Kg", "factoryNetAmount_Kg", "glx"];
    const sumTableContentRownames = ["fieldCollectionPointName", "fieldNumberOfUnits", "fieldGrossAmount", "factoryGrossAmount", "glx"];

    const [contentRowNames, setContentRowNames] = useState([]);
    const [fieldColumnNames, setFieldColumnNames] = useState([]);
    const [factoryColumnNames, setFactoryColumnNames] = useState([]);

    const initialCsvHeaders = [
        { label: "Route Code", value: "fieldCollectionPointCode" },
        { label: "Route Name", value: "fieldCollectionPointName" },
        { label: "Card Number", value: "fieldCardNumber" },
        { label: "Reg Number", value: "filedRegistrationNumber" },
        { label: "Date", value: "filedDate" },
        { label: "Time", value: "filedTime" },
        { label: "Leaf Type", value: "collectionTypeName" },
        { label: "Tag Number", value: "filedTagNumber" },
        { label: "Field Gross /Kg", value: "fieldGrossAmount_Kg" },
        { label: "Field Net /Kg", value: "fieldNetAmount_Kg" },
        { label: "Factory Gross /Kg", value: "factoryGrossAmount_Kg" },
        { label: "Factory Net /Kg", value: "factoryNetAmount_Kg" },
        { label: "G/L/X", value: "glx" }
    ]
    const [csvHeaders, setCsvHeaders] = useState([]);

    const [reportData, setReportData] = useState([]);
    const [fieldDeductions, setFieldDeductions] = useState([]);
    const [factoryDedutions, setFactoryDeductions] = useState([]);
    const [fullTotalRow, setFullTotalRow] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const [sumTableData, setSumTableData] = useState([]);
    const [sumTableTotal, setSumTableTotal] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown(),
        )
    }, [leafCollectionVariance.groupID])

    useEffect(() => {
        trackPromise(
            getRoutesForDropDown()
        )
    }, [leafCollectionVariance.factoryID])

    function handleGroupChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            groupID: target.value,
            factoryID: "0",
            routeID: "0"

        });
        setIsTableHide(true);
    }

    function handleFactoryChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            factoryID: target.value,
            routeID: "0"
        });
        setIsTableHide(true);
    }

    function handleRouteChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            routeID: target.value,
        });
        setIsTableHide(true);
    }

    function handleFromDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            date: target.value,
        });
        setIsTableHide(true);
    }

    function handleVarianceLimitChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            varinaceLimit: target.value,
        });
        setIsTableHide(true);
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, LeafCollectionVarianceReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWLEAFCOLLECTIONVARIANCEDETAILSREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(leafCollectionVariance.groupID);
        setFactories(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(leafCollectionVariance.factoryID);
        setRoutes(data);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }


    async function handleSearch(e) {

        e.preventDefault();
        setIsTableHide(true);

        const errorMessages = validate(schema, leafCollectionVariance);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(leafCollectionVariance);

        const result = await services.getLeafCollectionVarianceReportData(leafCollectionVariance);
        
        var contentResult = generateTableInitializationData(result);

        var fieldData = mergeFieldData(result.fieldData);
        var factoryData = mergeFactoryData(result.factoryData);

        var finalResult = mergeFactoryAndFieldData(fieldData, factoryData);
        mergeSumTableFactoryAndFieldData(result.factorySumData, result.fieldSumData);

        if (leafCollectionVariance.varinaceLimit.trim() !== "") {
            finalResult = finalResult.filter(x => (parseInt(x.glx) >= parseInt(leafCollectionVariance.varinaceLimit) * -1) &&
                (parseInt(x.glx) <= parseInt(leafCollectionVariance.varinaceLimit)))
        }

        var totalRowResult = calculateTotal(finalResult);

        if (finalResult.length > 0) {
            setIsTableHide(false);
            setReportData(finalResult);
            createDataTable(contentResult, ["#leafCollectionSummary", "#leafCollectionSummaryPdf"]);

            generateCsvData(finalResult, totalRowResult, contentResult);
        }
    }

    function calculateTotal(data) {
        var total = [];
        var bagCount = 0;
        var glx = 0;

        data.forEach(x => {
            bagCount++;
            glx += x.glx;
            for (var property in x) {
                if (property.includes("_Kg")) {
                    total.push({ name: property, value: x[property] });
                }
            }
        });

        const res = Array.from(total.reduce(
            (m, { name, value }) => m.set(name, (m.get(name) || 0) + value), new Map
        ), ([name, value]) => ({ name, value }));

        res.glx = glx;
        res.bagCount = bagCount;

        setFullTotalRow(res);
        return res;
    }

    function mergeSumTableFactoryAndFieldData(factorySumData, fieldSumData) {
        var joinedResult = [];
        var joinedArray = _.merge(_.keyBy(fieldSumData, 'fieldCollectionPointID'), _.keyBy(factorySumData, 'factoryCollectionPointID'));
        
        var total = {
            fieldCollectionPointName: "Total",
            fieldNumberOfUnits: 0,
            fieldGrossAmount: 0,
            factoryGrossAmount: 0,
            glx: 0
        }

        Object.keys(joinedArray).forEach((x, i) => {
            joinedArray[x].glx = (joinedArray[x].factoryGrossAmount === undefined ? 0 : joinedArray[x].factoryGrossAmount)
                - (joinedArray[x].fieldGrossAmount === undefined ? 0 : joinedArray[x].fieldGrossAmount);
            joinedResult.push(joinedArray[x])
        });

        joinedResult.forEach((x, i) => {
            for (var proerty in x) {
                if (proerty !== "fieldCollectionPointName") {
                    total[proerty] = (total[proerty] === undefined ? 0 : parseFloat(total[proerty]))
                        + (x[proerty] === undefined ? 0 : parseFloat(x[proerty]))
                }
            }
        });
        setSumTableTotal(total);
        setSumTableData(joinedResult);
    }

    function generateCsvData(data, totalRowResult, contentResult) {

        var copyOfData = _.cloneDeep(data);
        var newRecord = { fieldCollectionPointCode: "Total" }

        newRecord.filedTagNumber = totalRowResult.bagCount;
        newRecord.glx = totalRowResult.glx;
        totalRowResult.forEach(x => {
            newRecord[x.name] = x.value === undefined ? (0).toFixed(2) : x.value.toFixed(2);
        })
        copyOfData.push(newRecord);
        setCsvData(copyOfData);
    }

    function generateTableInitializationData(data) {

        var copyOfInitialContentRownames = initialContentRownames;
        var copyOfInitialCsvHeaders = initialCsvHeaders;

        var fieldDeductionNames = [];
        var fieldDeductionIds = [];
        var factoryDeductionNames = [];
        var factoryDeductionIds = [];

        var csvFieldsData = [];
        var csvFactoryData = [];

        data.fieldData.forEach(x => {
            if ((x.fieldDeductionTypeName !== null && x.fieldDeductionTypeName !== undefined) && x.filedDeductionTempId !== 0) {
                fieldDeductionNames.push(x.fieldDeductionTypeName);
                fieldDeductionIds.push((x.filedDeductionTempId + "_Kg_Fi"));
                csvFieldsData.push({ label: ("Field " + x.fieldDeductionTypeName), value: (x.filedDeductionTempId + "_Kg_Fi") })
            }
        });

        data.factoryData.forEach(x => {
            if ((x.factoryDeductionTypeName !== null && x.factoryDeductionTypeName !== undefined) && x.factoryDeductionTempId !== 0) {
                factoryDeductionNames.push(x.factoryDeductionTypeName);
                factoryDeductionIds.push((x.factoryDeductionTempId + "_Kg_Fa"));
                csvFactoryData.push({ label: ("Factory " + x.factoryDeductionTypeName), value: (x.factoryDeductionTempId + "_Kg_Fa") })
            }
        });

        fieldDeductionNames = [...new Set(fieldDeductionNames)];
        fieldDeductionIds = [...new Set(fieldDeductionIds)];
        factoryDeductionNames = [...new Set(factoryDeductionNames)];
        factoryDeductionIds = [...new Set(factoryDeductionIds)];

        csvFactoryData = csvFactoryData.filter((v, i, a) => a.findIndex(t => (t.label === v.label && t.value === v.value)) === i);
        csvFieldsData = csvFieldsData.filter((v, i, a) => a.findIndex(t => (t.label === v.label && t.value === v.value)) === i);

        copyOfInitialContentRownames.splice(9, 0, ...fieldDeductionIds);
        copyOfInitialContentRownames.splice((11 + fieldDeductionIds.length), 0, ...factoryDeductionIds);

        copyOfInitialCsvHeaders.splice(9, 0, ...csvFieldsData);
        copyOfInitialCsvHeaders.splice((11 + fieldDeductionIds.length), 0, ...csvFactoryData);

        setCsvHeaders(copyOfInitialCsvHeaders);

        setContentRowNames(copyOfInitialContentRownames);
        setFieldColumnNames(fieldDeductionNames);
        setFactoryColumnNames(factoryDeductionNames);

        return {
            contentRowNames: copyOfInitialContentRownames,
            fieldDeductionNames: fieldDeductionNames,
            factoryDeductionNames: factoryDeductionNames,
            fieldDeductionIds: fieldDeductionIds,
            csvHeadersData: copyOfInitialCsvHeaders
        }
    }

    function mergeFactoryAndFieldData(fieldData, factoryData) {
        var joinedResult = [];
        var joinedArray = _.merge(_.keyBy(fieldData, 'filedTagNumber'), _.keyBy(factoryData, 'factoryTagNumber'));

        Object.keys(joinedArray).forEach((x, i) => {
            joinedArray[x].glx = (joinedArray[x].factoryGrossAmount_Kg === undefined ? 0 : joinedArray[x].factoryGrossAmount_Kg)
                - (joinedArray[x].fieldGrossAmount_Kg === undefined ? 0 : joinedArray[x].fieldGrossAmount_Kg);
            joinedResult.push(joinedArray[x])
        });

        return joinedResult;
    }

    function mergeFactoryData(data) {
        var mergedResult = [];

        data.forEach(x => {
            if (mergedResult.length === 0) {
                mergedResult.push(setDefaultFactoryValues(x));
            } else {
                var duplicateRecord = mergedResult.find(a => a.factoryWeighDetailID === x.factoryWeighDetailID
                    && a.factoryCollectionPointID === x.factoryCollectionPointID);

                if (duplicateRecord) {
                    duplicateRecord[x.factoryDeductionTempId + "_Kg_Fa"] = (duplicateRecord[x.factoryDeductionTempId + "_Kg_Fa"] === undefined ? 0
                        : parseFloat(duplicateRecord[x.factoryDeductionTempId + "_Kg_Fa"])) + parseFloat(x.factoryDeductionAmount);
                } else {
                    mergedResult.push(setDefaultFactoryValues(x));
                }

            }
        });

        return mergedResult;
    }

    function mergeFieldData(data) {
        var mergedResult = [];

        data.forEach(x => {
            if (mergedResult.length === 0) {
                mergedResult.push(setDefaultFieldValues(x));
            } else {
                var duplicateRecord = mergedResult.find(a => a.productCollectionDetailsID === x.productCollectionDetailsID
                    && a.fieldCollectionPointID === x.fieldCollectionPointID);

                if (duplicateRecord) {
                    duplicateRecord[x.filedDeductionTempId + "_Kg_Fi"] = (duplicateRecord[x.filedDeductionTempId + "_Kg_Fi"] === undefined ? 0
                        : parseFloat(duplicateRecord[x.filedDeductionTempId + "_Kg_Fi"])) + parseFloat(x.fieldDeductionAmount);
                } else {
                    mergedResult.push(setDefaultFieldValues(x));
                }

            }
        });

        return mergedResult;
    }

    function setDefaultFieldValues(record) {
        var newRecord = {
            type: 1,
            fieldCardNumber: record.fieldCardNumber,
            fieldCollectionPointCode: record.fieldCollectionPointCode,
            fieldCollectionPointID: record.fieldCollectionPointID,
            fieldCollectionPointName: record.fieldCollectionPointName,
            fieldGrossAmount_Kg: record.fieldGrossAmount,
            fieldNetAmount_Kg: record.fieldNetAmount,
            fieldActualAmount_Kg: record.FieldActualAmount,
            collectionTypeName: record.collectionTypeName,
            filedRegistrationNumber: record.filedRegistrationNumber,
            filedTagNumber: record.filedTagNumber,
            productCollectionDetailsID: record.productCollectionDetailsID,
            productCollectionID: record.productCollectionID,
            filedDate: record.weightReadTime.split("T")[0],
            filedTime: record.weightReadTime.split("T")[1]
        };

        if (record.filedDeductionTempId !== null && record.fieldDeductionAmount !== null) {
            newRecord[record.filedDeductionTempId + "_Kg_Fi"] = record.fieldDeductionAmount;
        }

        return newRecord;
    }

    function setDefaultFactoryValues(record) {
        var newRecord = {
            type: 2,
            factoryCollectionPointID: record.factoryCollectionPointID,
            factoryCollectionPointName: record.factoryCollectionPointName,
            factoryGrossAmount_Kg: record.factoryGrossAmount,
            factoryNetAmount_Kg: record.factoryNetAmount,
            factoryActualAmount_Kg: record.factoryActualAmount,
            factoryTagNumber: record.factoryTagNumber,
            factoryWeighDetailID: record.factoryWeighDetailID,
            factoryDate: record.weightReadTime.split("T")[0],
            factoryTime: record.weightReadTime.split("T")[1]
        };

        if (record.factoryDeductionTempId !== null && record.factoryDeductionAmount !== null) {
            newRecord[record.factoryDeductionTempId + "_Kg_Fa"] = record.factoryDeductionAmount;
        }

        return newRecord;
    }

    function createDataTable(contentResult, dataTables) {
        dataTables.forEach(x => {
            $(x).DataTable({
                destroy: x === '#leafCollectionSummaryPdf' ? true : false,
                searching: x === '#leafCollectionSummaryPdf' ? false : true,
                paging: x === '#leafCollectionSummaryPdf' ? false : true,
                scrollX: false,
                rowGroup: {
                    startRender: null,
                    endRender: function (rows, group) {

                        var dynamicCountVariable = [];

                        for (var i = 0; i < contentResult.contentRowNames.length; ++i) {
                            if (i === 7) {
                                dynamicCountVariable[i] = rows.count();
                            } else if (i > 7) {
                                dynamicCountVariable[i] = rows
                                    .data()
                                    .pluck(i)
                                    .reduce(function (a, b) {
                                        return a + b * 1;
                                    }, 0);
                            }
                        }

                        var rowData = '';

                        for (var i = 0; i < contentResult.contentRowNames.length; ++i) {
                            if (i === 7) {
                                rowData += '<td style="text-align:right"><b>' + dynamicCountVariable[i] + '</b></td>';
                            } else if (i > 7) {
                                rowData += '<td style="text-align:right"><b>' + dynamicCountVariable[i].toFixed(2) + '</b></td>';
                            // } else if (contentResult.contentRowNames.length === i + 1) {
                            //     rowData += '<td/>';
                            }
                        }

                        return $('<tr/>')
                            .append('<td colspan="7"><b>Total for ' + group + '</b></td>')
                            .append(rowData);
                    },
                    dataSrc: 1
                }
            })
        });
    }

    function createFile() {
        var settings = {
            sheetName: 'LeafCollectionVarianceReport',
            fileName: 'Leaf Collection Variance Report',
            writeOptions: {}
        }
        xlsx(csvHeaders, csvData, settings, true)
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setLeafCollectionDetails({
            ...leafCollectionVariance,
            routeID: "0",
            date: "",
            varinaceLimit: ""
        });
        setIsTableHide(true);
        setErrors("");
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            factory: factories[searchForm.factoryID],
            route: routes[searchForm.routeID],
            varinaceLimit: searchForm.varinaceLimit,
            date: searchForm.date,
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Leaf Collection Variance Details Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={leafCollectionVariance.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="factoryID"
                                            id="factoryID"
                                            name="factoryID"
                                            value={leafCollectionVariance.factoryID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleFactoryChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Route</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="routeID"
                                            id="routeID"
                                            name="routeID"
                                            value={leafCollectionVariance.routeID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="searchDate">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="date"
                                            name="date"
                                            type="date"
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-3 pb-1">
                                        <TextField fullWidth label="Variance Limit +/-"
                                            name="varinaceLimit"
                                            id="varinaceLimit"
                                            value={leafCollectionVariance.varinaceLimit}
                                            type="number"
                                            onChange={(e) => handleVarianceLimitChange(e.target)} />
                                        {errors["varinaceLimit"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["varinaceLimit"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, leafCollectionVariance)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <div className="row pb-3">
                                        <div className="col-md-6">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th style={{ fontWeight: "bold" }}>Route Name</th>
                                                        <th style={{ fontWeight: "bold" }}>Bag Count</th>
                                                        <th style={{ fontWeight: "bold" }}>Field Gross /Kg</th>
                                                        <th style={{ fontWeight: "bold" }}>Factory Gross /Kg</th>
                                                        <th style={{ fontWeight: "bold" }}>G/L/X</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <TableContentForSumLeafCollectionVarianceReport
                                                        data={sumTableData}
                                                        contentRowNames={sumTableContentRownames}
                                                        hasEdit={false}
                                                    />
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <th style={{ fontWeight: "bold" }}>Total</th>
                                                        <th style={{ textAlign: "right",fontWeight: "bold" }}>{sumTableTotal.fieldNumberOfUnits}</th>
                                                        <th style={{ textAlign: "right",fontWeight: "bold" }}>{sumTableTotal.fieldGrossAmount !== undefined ?
                                                            sumTableTotal.fieldGrossAmount.toFixed(2) : (0).toFixed(2)}</th>
                                                        <th style={{ textAlign: "right",fontWeight: "bold" }}>{sumTableTotal.factoryGrossAmount !== undefined ?
                                                            sumTableTotal.factoryGrossAmount.toFixed(2) : (0).toFixed(2)}</th>
                                                        <th style={{ textAlign: "right",fontWeight: "bold" }}>{sumTableTotal.glx !== undefined ?
                                                            sumTableTotal.glx.toFixed(2) : (0).toFixed(2)} </th>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div>
                                                <table id="leafCollectionSummary"
                                                    style={{ display: "block", overflowX: "auto", whiteSpace: "nowrap"
                                                    , maxWidth: "1400px", borderColor: "white" }}>
                                                    <thead>
                                                        <tr>
                                                            <th rowSpan="2">Route Code</th>
                                                            <th rowSpan="2">Route Name</th>
                                                            <th rowSpan="2">Card Number</th>
                                                            <th rowSpan="2">Reg Number</th>
                                                            <th rowSpan="2">Date</th>
                                                            <th rowSpan="2">Time</th>
                                                            <th rowSpan="2">Leaf Type</th>
                                                            <th rowSpan="2">Tag Number</th>
                                                            <th style={{ textAlign: "center" }} colSpan={2 + fieldColumnNames.length}>Field</th>
                                                            <th style={{ textAlign: "center" }} colSpan={2 + factoryColumnNames.length}>Factory</th>
                                                            <th rowSpan="2">G/L/X</th>
                                                        </tr>
                                                        <tr>
                                                            <th>Gross /Kg</th>
                                                            {fieldColumnNames.map((x, index) => {
                                                                return (
                                                                    <th scope="col" key={index}>{x}</th>
                                                                )
                                                            })}
                                                            <th>Net /Kg</th>
                                                            <th>Gross /Kg</th>
                                                            {factoryColumnNames.map((x, index) => {
                                                                return (
                                                                    <th scope="col" key={index}>{x}</th>
                                                                )
                                                            })}
                                                            <th>Net /Kg</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <TableContentForLeafCollectionVarianceReport
                                                            data={reportData}
                                                            contentRowNames={contentRowNames}
                                                            hasEdit={false}
                                                        />
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <th colSpan="7">Total</th>
                                                            <th style={{ textAlign: "right" }}>{fullTotalRow.bagCount}</th>
                                                            {contentRowNames.map((x, i) => {
                                                                var res = fullTotalRow.find(y => y.name === x);
                                                                if (res) {
                                                                    return (
                                                                        <th key={i} style={{ textAlign: "right" }}>{res.value.toFixed(2)}</th>
                                                                    );
                                                                } else if (res === undefined && x.includes("_Kg") ) {
                                                                    return (
                                                                        <th key={i} style={{ textAlign: "right" }}>{(0).toFixed(2)}</th>
                                                                    );
                                                                }

                                                            })}
                                                            <th style={{ textAlign: "right",fontWeight: "bold" }}>{fullTotalRow.glx !== undefined ?
                                                            fullTotalRow.glx.toFixed(2) : (0).toFixed(2)} </th>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-4">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Route Summary Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData} fieldColumnNames={fieldColumnNames}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} sumTableTotal={sumTableTotal}
                                            factoryColumnNames={factoryColumnNames} fullTotalRow={fullTotalRow}
                                            sumTableData={sumTableData} sumTableContentRownames={sumTableContentRownames} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
